import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "8cb8e9eb-9d43-4ef7-8c3d-6c3c15b6d060",
        authority: "https://1stopvatb2c.b2clogin.com/1stopvatb2c.onmicrosoft.com/B2C_1_susi",
        knownAuthorities: ["1stopvatb2c.b2clogin.com"],
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
};